import { Observable } from 'rxjs';
import { map, delay } from 'rxjs/operators';
import { openBlobFile } from '@awp/core/utils';
import { SirenHttp } from './services/siren-http.service';
import { SirenLink, Parameters } from './model';

export function downloadDocument(
  http: SirenHttp,
  fileName: string,
  link: SirenLink,
  params?: Parameters,
  self?: boolean): Observable<any> {

  if (http == null) {
    throw Error('Http is not defined');
  }
  if (link == null) {
    throw new Error('Document link is not defined');
  }

  return downloadFile(http, fileName, link.href, params, self);
}

export function downloadFile(http: SirenHttp, fileName: string, url: string, params?: Parameters, self?: boolean): Observable<boolean> {
  if (http == null) {
    throw Error('Http is not defined');
  }

  return http.getBlob(url, params).pipe(
      delay(500),
      map(fileBlob => {
        openBlobFile(fileBlob, fileName, self);
        return true;
      })
    );
}